import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Grid from '@mui/material/Grid2';
import { useAppStore } from "../../../stores";
import _ from "lodash";

interface IRevisionContent {
  current?: {
    detail: string;
    createTimestamp: string;
    user: { firstName: string; lastName: string };
    objectType?: string;
    comment?: string | null;
  };
  previous?: {
    detail: string;
    createTimestamp: string;
    user: { firstName: string; lastName: string };
  } | null;
}

interface IAuditAndHistoryRevisionSingleRecordContentDisplayProps {
  selectedRevision: IRevisionContent;
}

function AuditAndHistoryRevisionSingleRecordContentDisplay(
  props: IAuditAndHistoryRevisionSingleRecordContentDisplayProps
) {
  // Zustand store
  const selectedRevisionContentLoaded = useAppStore(
    (state) => state.auditAndHistoryRevisions?.selectedRevisionContentLoadedSuccessfully || false
  );

  const selectedRevisionContent = useAppStore(
    (state) => state.auditAndHistoryRevisions?.selectedRevisionContent
  ) as IRevisionContent | null;

  const formatCorrectRevisions = (currentOrPrevious: string) => {
    if (!selectedRevisionContent) return ["No details available"];
    const revisionContent =
      currentOrPrevious === "current"
        ? selectedRevisionContent.current
        : selectedRevisionContent.previous;
    if (!revisionContent || revisionContent.detail === "") {
      return ["No details available"];
    }
    if (revisionContent.detail.includes("\n")) {
      const splitRevisions = revisionContent.detail.split("\n");
      return _.filter(splitRevisions, function (revision) {
        return revision !== "";
      });
    }
    return [revisionContent.detail];
  };

  const displayRevisions = (revisions: string[], currentOrPrevious: string) => {
    if (!selectedRevisionContent) return <span>Content not available</span>;
    const revisionContent =
      currentOrPrevious === "current"
        ? selectedRevisionContent.current
        : selectedRevisionContent.previous;
    if (revisionContent) {
      return revisions.map((revision: any, index: number) => {
        return (
          <div key={index} style={{ width: "100%" }}>
            <span>
              {currentOrPrevious === "current" ? <CheckIcon /> : <CloseIcon />}
            </span>{" "}
            <span>{revision}</span>{" "}
          </div>
        );
      });
    }
    return <span>Content not available</span>;
  };

  return (
    <Grid container size={{ xs: 12 }}>
      {selectedRevisionContentLoaded && selectedRevisionContent && (
        <Grid container size={{ xs: 12 }} className="pt-3 pb-2" style={{ color: "#8a8f9b" }}>
          <Grid container size={{ xs: 12 }} spacing={1}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Grid size={{ xs: 12, md: 6 }} className="pb-2">
                <div>
                  {selectedRevisionContent.previous ? (
                    <div>
                      Previous @{" "}
                      {new Date(
                        selectedRevisionContent.previous.createTimestamp
                      ).toLocaleString()}
                    </div>
                  ) : (
                    <div>
                      <span>No content available</span>
                    </div>
                  )}
                  <div>
                    {selectedRevisionContent.previous ? (
                      `${selectedRevisionContent.previous.user.firstName} ${selectedRevisionContent.previous.user.lastName}`
                    ) : (
                      <div>
                        <span>No content available</span>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>

              <Grid
                style={{
                  border: "2px solid #c70d1e",
                  backgroundColor: "#ffd5d5",
                  padding: "1.5rem",
                }}
              >
                {selectedRevisionContent.previous ? (
                  displayRevisions(
                    formatCorrectRevisions("previous"),
                    "previous"
                  )
                ) : (
                  <div>
                    <span>No content available</span>
                  </div>
                )}
              </Grid>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className="pb-2">
              <Grid size={{ xs: 12, md: 6 }} className="pb-2">
                <div>
                  {selectedRevisionContent.current ? (
                    <div>
                      Current @{" "}
                      {new Date(
                        selectedRevisionContent.current.createTimestamp
                      ).toLocaleString()}
                    </div>
                  ) : (
                    <div>
                      <span>No content available</span>
                    </div>
                  )}
                  <div>
                    {selectedRevisionContent.current ? (
                      `${selectedRevisionContent.current.user.firstName} ${selectedRevisionContent.current.user.lastName}`
                    ) : (
                      <div>
                        <span>No content available</span>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>

              <Grid
                style={{
                  border: "2px solid #329b2f",
                  backgroundColor: "#eaffe9",
                  padding: "1.5rem",
                }}
              >
                {selectedRevisionContent.current ? (
                  displayRevisions(formatCorrectRevisions("current"), "current")
                ) : (
                  <div>
                    <span>No content available</span>
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default AuditAndHistoryRevisionSingleRecordContentDisplay;
